import { useAtomValue } from "jotai";
import { warningAlertStateAtom } from "@zapier/canvas-state";
import { WarningAlert } from "../WarningAlert";
import { AlertPositioner } from "../AlertPositioner";
import { useUnsavedChangesWarning } from "../../hooks/useUnsavedChangesWarning";

/**
 * Manages the display of the global WarningAlert component based on warningAlertStateAtom.
 * Also activates the useUnsavedChangesWarning hook to handle beforeunload events.
 */
export function WarningManager() {
  // Activate the hook to handle beforeunload and provide trigger functions
  useUnsavedChangesWarning();

  const alertState = useAtomValue(warningAlertStateAtom);

  if (!alertState.isOpen) {
    return null;
  }

  return (
    <AlertPositioner>
      <WarningAlert
        isOpen={alertState.isOpen}
        title={alertState.title}
        message={alertState.message}
        primaryButtonText={alertState.primaryButtonText}
        secondaryButtonText={alertState.secondaryButtonText}
        status={alertState.status}
        onPrimaryAction={alertState.onPrimaryAction}
        // The hook's closeWarning function handles the secondary action if not overridden
        onSecondaryAction={
          alertState.onSecondaryAction || (() => alertState.onPrimaryAction())
        }
        isPrimaryLoading={alertState.isPrimaryLoading}
      />
    </AlertPositioner>
  );
}
